// @Version: 1.0.0
import { Component, Input, OnDestroy } from '@angular/core';
import { TRANSLATE_PATH } from '../../shared.model';

@Component({
   selector: 'app-spinner',
   templateUrl: './spinner.component.html',
   standalone: false
})

export class SpinnerComponent {

   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
   @Input() public path: string = TRANSLATE_PATH.SPINNER_PATH;
}